import { api, pollJobUntilDone } from "./api";

// Email-gated free generation. Runs the SAME full generator on the SAME
// payload as a paid user — the only additions are the email + consent
// captured by the gate. Returns { activity, delivery }.
export const freeGenerateActivity = async (payload, { email, marketingConsent }) => {
  const { data: started } = await api.post(
    "/free-generate",
    { ...payload, email, marketing_consent: !!marketingConsent },
    { timeout: 30000 }
  );
  const jobId = started?.job_id;
  if (!jobId) throw new Error("Server did not return a job id");
  const job = await pollJobUntilDone({
    jobId,
    pollUrl: `/free-generate/jobs/${jobId}`,
    errorPrefix: "Generation",
  });
  return { activity: job.activity, delivery: job.free_delivery || null, grantId: started.grant_id };
};

export const resendFreePackage = async (grantId) => {
  const { data } = await api.post("/free-generate/resend", { grant_id: grantId });
  return data;
};
